export interface ModalSlice {
  isModalLoading: boolean;
  setIsModalLoading: (v: boolean) => void;
}

export const createModalSlice = (set: any): ModalSlice => ({
  isModalLoading: false,
  setIsModalLoading: (v) => set({ isModalLoading: v }),
});
